import { isUserLoggedIn } from "@/auth/utils";
// @todo maybe we can do it in one object like emailinbox.js
export default [
    {
        path: "/team-chat",
        name: "team-chat",
        component: () => import("@/views/modules/team-chat/teamChat.vue"),
        meta: {
            contentRenderer: "sidebar-left",
            contentClass: "team-chat-application",
            resource: "teamChats",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/team-chat/:chatId",
        name: "team-chat-id",
        component: () => import("@/views/modules/team-chat/teamChat.vue"),
        meta: {
            contentRenderer: "sidebar-left",
            contentClass: "team-chat-application",
            navActiveLink: "team-chat",
            resource: "teamChats",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
